import { keyframes } from '@mui/material/styles';

export const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

export const animations = {
  pulse: `${pulse} 2s infinite`,
};

